import { DEFAULT_THEME_COLOR } from 'appenv';
import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ClickableText from 'components/ClickableText';

const RegisterStickyContainer = styled.div`
  text-align: center;
  padding: 0 3px;
  padding-bottom: 24px;
  color: #282B40;
  margin-top: 4em;
  font-weight: bold;
  font-size: 1.2em;
  display: flex;
  flex-grow: 1;
  align-items: flex-end;
  justify-content: center;
`;

const RegisterActionButton = () => {
  const { t } = useTranslation();
  const themeColor = useSelector((s) => (s as any).eventConfigs.themeColor);
  const regLink = useSelector((state: any) => state.eventConfigs.landing.regLink);
  const resolvedColor = themeColor || DEFAULT_THEME_COLOR;

  const onRegisterNowBtnClick = useCallback(() => {
    window.open(regLink, '_blank');
  }, [regLink]);

  return (
    <RegisterStickyContainer>
      {`${t('lobby.registration.new_user', 'New user?')} `}
      <ClickableText
        onClick={onRegisterNowBtnClick}
        color={resolvedColor}
      >
        {t('lobby.registration.register_now', 'Register now')}
      </ClickableText>
    </RegisterStickyContainer>
  );
};

export default RegisterActionButton;
